module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-timeline-slider"
  }, [_c('slider', {
    attrs: {
      "value": _vm.position
    },
    on: {
      "update": _vm.onSliderUpdate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "time-readout"
  }, [_vm._v(_vm._s(_vm.msToTime(_vm.currentTime * 1000)))]), _vm._v(" "), _c('div', {
    staticClass: "time-readout right"
  }, [_vm._v(" - " + _vm._s(_vm.msToTime(_vm.timeLeft * 1000)))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a431a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/TimelineSlider.vue
// module id = 195
// module chunks = 1